export default import.meta.ROLLDOWN_FILE_URL_Ngmgj7KrmSrUoXH_NFNtFA